import { Trans } from '@lingui/macro';
import React, { FC, useState, useEffect } from 'react'
import { Carousel } from 'react-bootstrap';
import Modal from 'react-modal';
import ReactQuill from 'react-quill';
import { isEmpty } from 'underscore';


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
    data: any;
    date: string;
}

export const EventModal: FC<ModalProps> = props => {
    const { toggle, setToggle, data, date } = props;

    var htmlObject = document.createElement('div');
    htmlObject.innerHTML = data['text'];

    const [images, setImages] = useState<any[]>([]);

    const onRequestClose = () => {
        setToggle(false);
    };

    const getImages = () => {
        let imgMass = []
        if (!isEmpty(data)) {
            for (let i = 1; i < 10; i++) {
                if (data[`image${i}`]) {
                    imgMass.push(data[`image${i}`]);
                }
            }
        }
        setImages(imgMass);
    };

    useEffect(() => {
        getImages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
                <div className="col">Автор: {data['author']}</div>
                <div className="col text-end"><Trans>Publication date</Trans>: {date}</div>
            </div>
            <form className="Modal__Body">
                <div className="form-group">
                    <h3 className="event-header text-center">{data['header']}</h3>
                    <div className="form-control">
                        <ReactQuill
                            value={data['text']}
                            className='react-quill'
                            readOnly={true}
                            theme={"bubble"}
                        />
                    </div>
                    <hr />
                    {!isEmpty(images) ?
                        <div className="form-control justify-content-center">
                            <h5><Trans>Photo Collection</Trans></h5>
                            <div className="col-8">
                                <Carousel>
                                    {images.map((url, i) => {
                                        return (
                                            <Carousel.Item key={i}>
                                                <img
                                                    className="d-block w-100"
                                                    src={url}
                                                    alt={`фото${i}`}
                                                />

                                            </Carousel.Item>
                                        )
                                    })}
                                </Carousel>
                            </div>
                        </div>
                        : null}
                </div>
            </form>
        </Modal>
    );
};